import { FC } from 'react'
import s from './NewsAuthor.module.sass'
import { useAppSelector } from '@app/model/store/client'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'
import { Title } from '@shared/ui/Typography/Title'
import { Text } from '@shared/ui/Typography/Text'
import { Avatar } from '@shared/ui/Media/Avatar'
import AvatarMargo from '@images/special-margo-1.webp'
import { NewsAuthorSkeleton } from '@pages/NewsItem/ui/NewsAuthor/index'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import type { TypeMappingNewsOutput } from '@shared/api/middleware/mappingAPI/news/type'

interface Props {
  className?: string
  news?: TypeMappingNewsOutput | null
}

const NewsAuthor: FC<Props> = ({ className = '', news: newsFromPage }) => {
  const storeNews = useAppSelector((store) => store.pages.news_item.news)
  const news = newsFromPage ?? storeNews
  const { isMobile } = useClientResponsive()

  if (!news) return <NewsAuthorSkeleton className={className} />

  const isSpecialAuthor = !!news.author && news.author.id === 156 && news.author.slug === 'margarita-zamuraeva'
  const newsItemAvatarAuthorSrc = isSpecialAuthor ? AvatarMargo.src : news.author?.avatar

  if (!news.author) return null

  return (
    <BlockBoundary>
      <div className={`${s.author} ${className}`}>
        <Avatar
          sizes={'XL'}
          className={s['author-avatar']}
          userName={news.author?.name}
          src={newsItemAvatarAuthorSrc}
        />

        <div className={s['author-text']}>
          {isMobile ? (
            <Text sizes={'M'} medium className={s['author-name']}>
              {news.author?.name}
            </Text>
          ) : (
            <Title sizes={'h2'} tag={'h5'} className={s['author-name']}>
              {news.author?.name}
            </Title>
          )}
        </div>
      </div>
    </BlockBoundary>
  )
}

export default NewsAuthor
